import { A4uCalendar as IconComponent } from '@adobe/react-spectrum-workflow/dist/Calendar.js';
import { Icon } from '@adobe/react-spectrum/Icon';
import React from 'react';
export default function Calendar(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement(IconComponent, null));
}